package com.example.mystybag.login.views

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import com.example.mystybag.common.ui.components.native.DefaultButtonType
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.style.TextAlign
import com.example.mystybag.core.resources.SRC
import dev.icerock.moko.resources.compose.painterResource
import com.example.mystybag.common.resources.SR
import com.example.mystybag.common.ui.components.native.DefaultButton
import com.example.mystybag.common.ui.components.native.Texts
import com.example.mystybag.common.ui.views.UIView
import com.example.mystybag.core.expected.PlatformHelper
import com.example.mystybag.core.ui.theme.LocalTheme.p114
import com.example.mystybag.core.ui.theme.LocalTheme.p152
import com.example.mystybag.core.ui.theme.LocalTheme.p16
import com.example.mystybag.core.ui.theme.LocalTheme.p24
import com.example.mystybag.core.ui.theme.LocalTheme.p32
import com.example.mystybag.core.ui.theme.LocalTheme.p8
import com.example.mystybag.core.views.AppTheme
import com.example.mystybag.login.logic.AddFirstBagPromptViewModel
import com.example.mystybag.login.views.views.AddFirstBagPromptWebView
import dev.icerock.moko.resources.compose.stringResource

@Composable
fun AddFirstBagPromptView(viewModel: AddFirstBagPromptViewModel) {
    if (PlatformHelper.isWeb) {
        AddFirstBagPromptWebView(viewModel)
        return
    }

    val colors = AppTheme.current.colors

    UIView(
        viewModel = viewModel,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Column(
            modifier = Modifier
                .fillMaxSize()
                .padding(start = p16, end = p16, top = p24),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center
        ) {
            Image(
                painter = painterResource(SRC.images.add_first_bag_icon),
                contentDescription = null,
                modifier = Modifier
                    .height(p152)
                    .width(p114)
                    .padding(bottom = p32),
                contentScale = ContentScale.Fit
            )

            Texts.HeadlineLarge(
                text = stringResource(SR.strings.add_first_bag),
                textAlign = TextAlign.Center,
                color = colors.onSurface,
                modifier = Modifier.fillMaxWidth()
            )

            Spacer(modifier = Modifier.height(p16))

            Texts.BodyLarge(
                text = stringResource(SR.strings.add_first_bag_message),
                textAlign = TextAlign.Center,
                color = colors.onSurface,
                modifier = Modifier.fillMaxWidth()
            )

            Spacer(modifier = Modifier.weight(1f))

            DefaultButton(
                type = DefaultButtonType.TERTIARY,
                caption = stringResource(SR.strings.skip_for_now),
                callback = { viewModel.onSkipClicked() },
                modifier = Modifier
                    .padding(bottom = p8)
            )

            DefaultButton(
                caption = stringResource(SR.strings.start_adding_bag),
                callback = {
                    viewModel.onStartAddingBag()
                },
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(bottom = p8)
            )
        }
    }
}
